import { render, staticRenderFns } from "./purchaseDetails.vue?vue&type=template&id=7644e9c5&scoped=true"
import script from "./purchaseDetails.vue?vue&type=script&lang=js"
export * from "./purchaseDetails.vue?vue&type=script&lang=js"
import style0 from "../../assets/commoon/css/common.css?vue&type=style&index=0&id=7644e9c5&prod&scoped=true&lang=css&external"
import style1 from "./purchaseDetails.vue?vue&type=style&index=1&id=7644e9c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7644e9c5",
  null
  
)

export default component.exports